import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import ClientDetailPage from "@/pages/ClientDetailPage";
import GeneratePage from "@/pages/GeneratePage";
import PublicScriptPage from "@/pages/PublicScriptPage";
import { Toaster } from "sonner";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="mono-label pulse-soft">Loading</div>
    </div>
  );
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function AuthGate({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Handle Emergent Google Auth callback synchronously — MUST run before Protected/AuthProvider auth checks.
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/auth" element={<AuthGate><AuthPage /></AuthGate>} />
      <Route path="/s/:token" element={<PublicScriptPage />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/clients/:clientId" element={<Protected><ClientDetailPage /></Protected>} />
      <Route path="/clients/:clientId/generate" element={<Protected><GeneratePage /></Protected>} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="bottom-right" theme="light" richColors />
      </div>
    </AuthProvider>
  );
}
